import { get } from '../../api';
import { queryParams } from './rules';

export const getProcessos = (filtros) => {
  return get(`/api/analise-desempenho/processos-web/tempos${queryParams(filtros)}`);
};

export const getProcessosByLote = ({ lote }) => {
  return get(`/api/analise-desempenho/processos-web/processos/${lote}`);
};

export const getProcesso = ({ id }) => {
  return get(`/api/analise-desempenho/processo-web/${id}`);
};
